// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"ZV","skip_info":"aW","skipped":"bW","modify_order":"cW","cancel_subscription_btn":"eW","byb":"fW","modify_order_outer":"gW","byb_edit_btn":"hW","modify_order_item":"iW","cancel_copy_wrapper":"jW","cancelled_copy":"kW"};
    if(module.hot) {
      // 1713809679332
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  